import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import i18nEn from './en.i18n.json';

const resources = {
  en: {
    translation: i18nEn,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
  });

  export default i18n;